import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { isEmptyEncounterId, currentEncounterId } from '@mona/pdms/data-access-combined';
import { isSameEncounterFilter } from '@mona/shared/utils';
import { AuditLogApi } from '../../infrastructure/audit-log.api';
import * as AuditLogActions from '../actions/audit.log.actions';
import { AuditLogState } from '../reducers/audit-log.reducer';

/**
 * AuditLogEffects : loadAuditLogs
 */
@Injectable()
export class AuditLogEffects {
    loadAuditLogs$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuditLogActions.loadAuditLogs),
            mergeMap(({ encounter }) =>
                this.auditLogApi.getAuditLogs(encounter).pipe(
                    isSameEncounterFilter(currentEncounterId(this.store), encounter.id),
                    map(auditLogs => {
                        return AuditLogActions.loadAuditLogsSuccess({ auditLogs });
                    }),
                    catchError(error => {
                        return of(AuditLogActions.loadAuditLogsFailure({ error }));
                    }),
                    takeUntil(isEmptyEncounterId(this.store)),
                ),
            ),
        ),
    );

    /**
     * Constructor
     * @param actions$
     * @param auditLogApi
     * @param store
     */
    constructor(private actions$: Actions, private auditLogApi: AuditLogApi, private store: Store<AuditLogState>) {}
}
